import { token } from '@atlaskit/tokens';
import { defaultStoreUtils } from '@databases/redux';
import type { DatabaseFieldType } from '@databases/types/database';
import { getReferencedJiraValues } from '@databases/utils/database/field-types/jiraIssueDetails';
import { getDatabaseEntryRequired } from '@databases/utils/database/utils';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import React, { type FunctionComponent, type CSSProperties } from 'react';

import type { ViewComponentProps } from './types';

const summaryTextStyle: CSSProperties = {
  whiteSpace: 'pre-line'
};

const containerStyle: CSSProperties = {
  listStyleType: 'none',
  padding: 0
};

const listItemStyle: CSSProperties = {
  marginTop: token('space.100')
};

const JiraSummaryValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.JIRA_ISSUE_DETAILS>
> = ({ contentId, field, entryId }) => {
  const summaryValues = defaultStoreUtils.useEqualSelector((state) => {
    const database = selectDatabaseByContentIdRequired(state, { contentId });
    const entry = entryId ? getDatabaseEntryRequired(database, entryId) : undefined;
    return getReferencedJiraValues({ database, field, entry }, state);
  });

  if (!summaryValues.length) {
    return null;
  }

  if (summaryValues.length === 1) {
    return <span style={summaryTextStyle}>{summaryValues[0]?.text ?? ''}</span>;
  }

  return (
    <ul style={containerStyle}>
      {summaryValues.map((value, index) => (
        <li key={index} style={index > 0 ? listItemStyle : undefined}>
          <span style={summaryTextStyle}>{value?.text ?? ''}</span>
        </li>
      ))}
    </ul>
  );
};

export default JiraSummaryValueView;
